// Money helpers — store as integer cents, display as "$1,234.56".
export function formatMoney(cents, currency = "USD") {
  if (cents == null || isNaN(Number(cents))) return "—";
  const value = Number(cents) / 100;
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `$${value.toFixed(2)}`;
  }
}

// Parse a free-form "1234.56" or "1,234.56" string into integer cents.
// Returns null if invalid.
export function parseAmountToCents(input) {
  if (input == null) return null;
  const cleaned = String(input).replace(/[,\s$]/g, "");
  if (cleaned === "" || !/^\d+(\.\d{0,2})?$/.test(cleaned)) return null;
  const [whole, frac = ""] = cleaned.split(".");
  const fracPadded = (frac + "00").slice(0, 2);
  const cents = parseInt(whole, 10) * 100 + parseInt(fracPadded || "0", 10);
  if (!Number.isFinite(cents) || cents <= 0) return null;
  return cents;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-US", {
      year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

// Convert a Date or ISO string to a "YYYY-MM-DD" string in local TZ for <input type="date">.
export function toDateInputValue(d) {
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Convert a "YYYY-MM-DD" input value to an ISO datetime at local noon UTC.
export function dateInputToIso(value) {
  if (!value) return null;
  return new Date(`${value}T12:00:00.000Z`).toISOString();
}
